import React from "react";
import InfoSection from "@components/pages/info/info_section";

function ServiceNumber() {
    return (
        <InfoSection title="Öryggis og gæðamál">
            <p>
                1819 hefur &thorn;&aacute; stefnu &iacute; &ouml;ryggis- og
                g&aelig;&eth;am&aacute;lum a&eth; tryggja &ouml;ryggi vi&eth;skiptavina,
                starfsf&oacute;lks og samstarfsa&eth;ila. F&eacute;laginu er &aelig;tla&eth; a&eth;
                tryggja &ouml;ryggi ver&eth;m&aelig;ta, samfelldan rekstur og l&aacute;gmarka
                hverskonar &aacute;h&aelig;ttu.
            </p>
            <p>
                F&eacute;lagi&eth; leggur &aacute;herslu &aacute; a&eth; hafa sk&yacute;ra stefnu
                &iacute; &thorn;essu efni &iacute; &thorn;v&iacute; skyni a&eth; standa
                v&ouml;r&eth; um &iacute;mynd s&iacute;na og or&eth;spor. L&ouml;g&eth; er
                &aacute;hersla &aacute; a&eth; byggja upp virka &ouml;ryggisvitun
                starfsf&oacute;lks, samstarfsa&eth;ila og vi&eth;skiptavina.
            </p>
            <p>
                F&eacute;lagi&eth; stefnir a&eth; &thorn;v&iacute; a&eth; uppl&yacute;singar
                fyrirt&aelig;kisins, samstarfsa&eth;ila og vi&eth;skiptamanna &thorn;ess s&eacute;u
                tryggilega var&eth;ar og &ouml;ryggi &thorn;eirra tryggt &aacute; vi&eth;eigandi
                h&aacute;tt.
            </p>
            <p>
                1819 starfar &iacute; samr&aelig;mi vi&eth; l&ouml;g og regluger&eth;ir og
                fyrirm&aelig;li og reglur stj&oacute;rnvalda til d&aelig;mis P&oacute;st- og
                Fjarskiptastofnunar og Pers&oacute;nuverndar.
            </p>
            <p>
                F&eacute;lagi&eth; mun leitast vi&eth; a&eth; tryggja a&eth; &thorn;j&oacute;nusta
                s&eacute; &aacute;vallt a&eth;gengileg fyrir vi&eth;skiptavini allan
                s&oacute;larhringinn. &THORN;&aacute; mun f&eacute;lagi&eth; tryggja &ouml;ryggi
                b&uacute;na&eth;ar, sem nau&eth;synlegur er til a&eth; vi&eth; getum veitt
                vi&eth;eigandi &thorn;j&oacute;nustu.
            </p>
            <p>
                &Iacute; samr&aacute;&eth;i vi&eth; t&aelig;knilega samstarfsa&eth;ila okkar hefur
                f&eacute;lagi&eth; sett starfsreglur var&eth;andi uppl&yacute;singa&ouml;ryggi
                &aacute;samt &thorn;v&iacute; a&eth; tryggja vi&eth;eigandi r&aacute;&eth;stafanir
                til a&eth; framfylgja &thorn;eim. &THORN;etta n&aelig;r me&eth;al annars til
                verndunar gagna og afritunart&ouml;ku. &THORN;&aacute; hefur f&eacute;lagi&eth; sett
                raunh&aelig;f markmi&eth; var&eth;andi &thorn;j&oacute;nustut&iacute;ma.
            </p>
            <p>
                Til a&eth; h&aacute;marka &ouml;ryggi notar f&eacute;lagi&eth; &Iacute;slykil
                &THORN;j&oacute;&eth;skr&aacute;ar &Iacute;slands, rafr&aelig;n skilr&iacute;ki,
                Facbook e&eth;a GSM vi&eth; innskr&aacute;ningar til a&eth; h&aacute;marka
                &ouml;ryggi. &THORN;annig ver&eth;ur ekki unnt a&eth; breyta uppl&yacute;singum
                hj&aacute; vi&eth;skiptavinum af &thorn;ri&eth;ja a&eth;ila. &Iacute;
                &thorn;v&iacute; felst miki&eth; &ouml;ryggi og pers&oacute;nuvernd. &THORN;annig er
                trygg&eth;ur grei&eth;ur a&eth;gangur til a&eth; breyta eigin skr&aacute;ningu og
                tryggt a&eth; &oacute;vi&eth;komandi geti ekki breytt skr&aacute;ningu annarra
                hj&aacute; 1819.
            </p>
            <p>
                Um 140.000 einstaklingar og fyrirt&aelig;ki nota &Iacute;slykil og fer &ouml;rt
                fj&ouml;lgandi.
            </p>
            <p>
                H&aelig;gt er a&eth; panta &Iacute;slykil samstundis &iacute; heimbanka e&eth;a
                &iacute; p&oacute;sti &aacute; l&ouml;gheimili:
            </p>
            <p>
                <a
                    href="https://innskraning.island.is/?panta=1"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://innskraning.island.is/?panta=1
                </a>
            </p>
            <p>
                Sj&aacute; n&aacute;nar um Innskr&aacute;ningar&thorn;j&oacute;nustu
                &Iacute;sland.is h&eacute;r:
            </p>
            <p>
                <a
                    href="https://www.island.is/innskraningarthjonusta"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://www.island.is/innskraningarthjonusta
                </a>
            </p>
        </InfoSection>
    );
}
export default ServiceNumber;
